export default __webpack_public_path__ + "static/media/image-action-4.ef82798e.jpg";